/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Tenant } from '../../models/tenant';
import { TenantUpdateConfigsRequest } from '../../models/tenant-update-configs-request';

export interface UpdateTenantConfigs$Params {

/**
 * Id of a resource.
 */
  id: string;
      body: TenantUpdateConfigsRequest
}

export function updateTenantConfigs(http: HttpClient, rootUrl: string, params: UpdateTenantConfigs$Params, context?: HttpContext): Observable<StrictHttpResponse<Tenant>> {
  const rb = new RequestBuilder(rootUrl, updateTenantConfigs.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {"style":"simple","explode":false});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tenant>;
    })
  );
}

updateTenantConfigs.PATH = '/api/v1/tenants/{id}';
